import { HTMLProps, forwardRef } from 'react';

import {
  Theme,
  WithStyles,
  createStyles,
  withStyles,
} from '@material-ui/core/styles';

import classNames from 'classnames';

const styles = (theme: Theme) =>
  createStyles({
    root: {
      padding: theme.spacing(3, 0),
      borderBottom: `1px solid ${theme.palette.divider}`,
      '&:first-child:not(:only-child)': {
        paddingTop: 0,
      },
      '&:last-child': {
        borderBottom: 'none',
      },
    },
  });

export interface SidebarSectionRootProps
  extends HTMLProps<HTMLDivElement>,
    WithStyles<typeof styles> {}

const SidebarSectionRoot = forwardRef<HTMLDivElement, SidebarSectionRootProps>(
  (props, ref) => {
    const { className, classes, children, ...rest } = props;

    return (
      <div
        ref={ref}
        data-testid="sidebar-section"
        className={classNames(className, classes.root)}
        {...rest}
      >
        {children}
      </div>
    );
  },
);

SidebarSectionRoot.displayName = 'SidebarSection.Root';

export default withStyles(styles)(SidebarSectionRoot);
